import {
  getNRandomElementsFromArray,
  getRandomElementFromArray
} from "seneca-common/utils/functions";

import { generateMultipleChoiceContent } from "../../multiplechoice/logic/content";
import { GenerateContentOptions } from "../../types";
import { TestableSentence, TestableWord } from "../../wordfill/types";
import { SELECTABLE_WORD_REGEX } from "../constants";
import {
  Content,
  ContentSource,
  SelectableSentence,
  SelectableWord
} from "../types";

const MAX_WRONG_ANSWERS = 4;

export const generateContent = (
  source: ContentSource,
  { testingActive }: GenerateContentOptions
): Content => {
  const {
    sentence,
    wrongAnswers,
    multipleChoiceQuestion,
    selectInstruction: instruction
  } = source;
  const testedWords = sentence.filter(word => typeof word !== "string");
  const testedWord = (getRandomElementFromArray(testedWords) as any).word;
  const replacementWord = getRandomElementFromArray(wrongAnswers[testedWord]);
  const possibleWrongAnswers = wrongAnswers[testedWord].filter(
    answer => answer !== replacementWord
  );
  const numberOfWrongAnswersToGet = Math.min(
    possibleWrongAnswers.length,
    MAX_WRONG_ANSWERS
  );
  const selectedWrongAnswers = getNRandomElementsFromArray(
    numberOfWrongAnswersToGet,
    possibleWrongAnswers
  );
  const selectableSentence = generateSelectableSentence(
    sentence,
    testedWord,
    replacementWord
  );
  const testedWordIndex = getSelectableWordIndex(selectableSentence);
  return {
    select: {
      correctWord: testedWord,
      wrongWord: replacementWord,
      testedWordIndex: testedWordIndex!,
      sentence: selectableSentence,
      instruction
    },
    multipleChoice: generateMultipleChoiceContent(
      {
        question: multipleChoiceQuestion,
        wrongAnswers: selectedWrongAnswers,
        correctAnswer: testedWord
      },
      // @ts-ignore
      {
        testingActive: true
      }
    )
  };
};

export const generateSelectableSentence = (
  sentence: TestableSentence,
  testedWord: string,
  replacementWord: string
): SelectableSentence => {
  return (
    sentence
      .map(word =>
        processTestableSentenceItem(word, testedWord, replacementWord)
      )
      // @ts-ignore
      .reduce((acc: any, item: any) => acc.concat(item), [])
  ); // flatten
};

const processTestableSentenceItem = (
  word: string | TestableWord,
  testedWord: string,
  replacementWord: string
): SelectableWord[] | string[] => {
  if (typeof word === "string") {
    return splitUpSelectableWords(word);
  } else if (word.word !== testedWord) {
    // word can be tested but isn't this time
    return [word.word];
  } else {
    // word is tested this time
    return [
      {
        word: replacementWord,
        shouldBeSelected: true
      }
    ];
  }
};

const splitUpSelectableWords = (word: string): string[] => {
  const selectableWords = word.match(SELECTABLE_WORD_REGEX);
  const nonWords = word.split(SELECTABLE_WORD_REGEX);
  const combined = [nonWords[0]];

  for (let i = 1; i < nonWords.length; i++) {
    combined.push(selectableWords![i - 1], nonWords[i]);
  }

  return combined.filter((str: string) => str);
};

export const getSelectableWordIndex = (sentence: SelectableSentence) => {
  for (let index = 0; index < sentence.length; index++) {
    if (typeof sentence[index] === "object") {
      return index;
    }
  }
};
